import { GetServerSidePropsContext, PreviewData } from 'next';

import { ParsedUrlQuery } from 'node:querystring';

import { PropertyTypeID } from '@klokhuis/core/ApiClient/Klokhuis';

import {
  getListingTypeIdsFromQueryParam,
  getListingTypeIdsFromDynamicRoutes,
} from './ListingRoutes';

export const getListingTypesFromUrl = async (
  propertyType: string,
  ctx: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>,
) => {
  let listingTypes: Array<PropertyTypeID> | null =
    getListingTypeIdsFromQueryParam(
      ctx.query.listingTypes?.toString().split(','),
    );
  if (!listingTypes || listingTypes.length < 1) {
    if (propertyType.toLowerCase() === 'properties') {
      return [];
    }
    listingTypes = getListingTypeIdsFromDynamicRoutes(propertyType);
  }
  return listingTypes;
};
